module.exports = __webpack_public_path__ + "img/circle.3eaa9fad.svg";